module.exports = __webpack_public_path__ + "static/img/3-3.b765182.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/3-3.png
// module id = 267
// module chunks = 0